'use strict'
module.exports = {
  type: 'return',
  count: 1,
  cabin: '',
  passengers: [
    {
      type: 'ADT'
    }
  ],
  arrivalDepTime: {
    start: '',
    end: ''
  },
  departureDepTime: {
    start: '2019-07-20',
    end: '2019-07-25'
  },
  departureAirport: [
    {
      type: 'country',
      value: 'DE'
    }
  ],
  arrivalAirport: [
    {
      type: 'airport',
      value: 'PMI'
    }
  ],
  duration: {
    min: 6,
    max: 8
  },
  connectioncount: {
    min: 0,
    max: 3
  }
}
